"use strict";

var AbstractValidator,
    LengthValidator,
    extend = function extend(child, parent) {
  for (var key in parent) {
    if (hasProp.call(parent, key)) child[key] = parent[key];
  }function ctor() {
    this.constructor = child;
  }ctor.prototype = parent.prototype;child.prototype = new ctor();child.__super__ = parent.prototype;return child;
},
    hasProp = ({}).hasOwnProperty;

AbstractValidator = require("./Abstract");

module.exports = LengthValidator = (function (superClass) {
  extend(LengthValidator, superClass);

  function LengthValidator() {
    return LengthValidator.__super__.constructor.apply(this, arguments);
  }

  LengthValidator.prototype.validate = function (value, name) {
    var errors;
    errors = [];
    if (this.options.max && this.options.max < value.length) {
      errors.push(name + " cannot be more than " + this.options.max + " characters.");
    }
    if (this.options.min && this.options.min > value.length) {
      errors.push(name + " must be more than " + this.options.min + " characters.");
    }
    if (errors.length > 0) {
      return errors;
    } else {
      return null;
    }
  };

  return LengthValidator;
})(AbstractValidator);


/*****************
 ** WEBPACK FOOTER
 ** ./lib/validators/Length.js
 ** module id = 602
 ** module chunks = 0
 **/